import { render } from "./ImprimirEtiquetaEstoque.vue?vue&type=template&id=644c21f4"
import script from "./ImprimirEtiquetaEstoque.vue?vue&type=script&lang=js"
export * from "./ImprimirEtiquetaEstoque.vue?vue&type=script&lang=js"

import "./ImprimirEtiquetaEstoque.vue?vue&type=style&index=0&id=644c21f4&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__